import {Text} from '@/components-v2/atoms/Text/Text'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {useProductReview} from '../../context/ProductReviewContext'
import {ProductReviewField} from './ProductReviewField'

/**
 * Renders a section with fields grouped by language.
 * Only displays fields marked with localized: true.
 * @param {Object} props
 * @param {import('../ProductReviewTabs/productReviewDataMap').ProductReviewSectionConfig} props.section Section configuration with multiLanguage flag.
 */
export const ProductReviewMultiLanguageSection = ({section}) => {
  const {productData, updateEditableField} = useProductReview()
  const languages = useFeatureFlagLanguages()

  return (
    <div key={section.id} className="flex flex-col divide-y divide-[var(--secondary-800)]">
      {languages.map(language => (
        <div key={language.code} className="flex flex-col border-t-[var(--secondary-800)]">
          <div className="border-b border-b-[var(--secondary-800)] py-2">
            <Text variant="bold">Language: {language.language}</Text>
          </div>
          <div className="divide-y divide-[var(--secondary-800)]">
            {section.fields
              ?.filter(field => field.localized)
              ?.map(field => {
                const sourceData = productData?.[field.source] ?? {}
                const value = sourceData?.[field.key]?.[language.code]

                // Compute effective required: true if field.required is true OR if requiredWhen condition is met
                let isRequired = field.required
                if (field.requiredWhen) {
                  const [source, key] = field.requiredWhen.field.split('.')
                  const conditionFieldValue = productData?.[source]?.[key]
                  isRequired = isRequired || conditionFieldValue === field.requiredWhen.value
                }

                // Compute effective editable: use editableWhen condition if present, otherwise fall back to field.editable
                let isEditable = field.editable
                if (field.editableWhen) {
                  const [source, key] = field.editableWhen.field.split('.')
                  const conditionFieldValue = productData?.[source]?.[key]
                  isEditable = conditionFieldValue === field.editableWhen.value
                }

                return (
                  <div key={`${section.id}-${field.key}-${language.code}`}>
                    <ProductReviewField
                      label={field.label}
                      editable={isEditable}
                      required={isRequired}
                      renderer={field.renderer}
                      value={value}
                      onChange={nextValue => updateEditableField(field.source, field.key, nextValue, language.code)}
                    />
                  </div>
                )
              })}
          </div>
        </div>
      ))}
    </div>
  )
}
